import { __assign } from "tslib";
import TrilogyOtp from '@trilogy-ds/react/lib/components/otp/Otp';
import React from 'react';
/**
 * OTP Code Component
 * @param value {string} Code Text Input
 * @param length {number} Code Size Number
 * @param disabled {boolean} Disabled OTP Code Input
 * @param error {boolean} OTP Code Input has error | Display error icon
 * @param onCompleted {Function} Return code input string
 * @param onChange {Function} onChange Input return current code
 * @param onFocus {Function} onFocus return if focused opt
 * @param autoFocus {boolean} Should auto focus otp
 * @param label {string} Label for OTP
 * @param help {string} error message to display
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal css classes
 */
var Otp = React.forwardRef(function (props, ref) {
    return React.createElement(TrilogyOtp, __assign({}, __assign(__assign({}, props), { title: 'Chiffre :x sur :y du code à usage unique' }), { ref: ref }));
});
export default Otp;
//# sourceMappingURL=Otp.js.map